export default {
    title: `<i class="fa fa-lg fa-pencil-square"></i> 링크와 이미지 넣기`,
    datas: [
        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 링크 걸기`
        },
        { type: "text",
            content: "링크는 괄호의 조합으로 적용 할수 있습니다. 규칙은 아래와 같습니다. "
        },
        { type: "code2", code: "md", drag: true,
            content: `[글자](링크주소)`
        },
        { type: "text",
            content: "메일주소나 그냥 url에 링크를 사용하려면 &lt>(부등호 괄호)를 사용할 수도 있습니다."
        },
        { type: "code2", code: "md", drag: true,
            content: `<메일주소 or 링크주소>`
        },
        { type: "text",
            content: "간단하게 사용해 볼까요?"
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section03/exam01.md",
            content:
`### Incheon Dev's Contacts

- [홈페이지](http://incheon.devs.co.kr)(<http://i.devs.co.kr>) 또는

- [오픈채팅방](http://chat.devs.co.kr)을 먼저 이용해 주세요.

- [메일문의](mailto:incheon.devs@gmail.com)는 <incheon.devs@gmail.com>로 해주세요.`
        },



        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 앵커(문서 내부 링크) 걸기`
        },
        { type: "text",
            content: "간혹 마크다운 문서의 내용이 길면 문서 내부에서도 스크롤이동을 위해 링크를 걸 수 있습니다."
            + `(ex> <a href="https://github.com/Alamofire/Alamofire/blob/master/Documentation/Usage.md" target="_blank">Alamofire Usage Page</a>)`
        },
        { type: "code2", code: "md", drag: true,
            content: `[글자](#제목)`
        },
        { type: "text",
            content: "보통 제목을 사용하면 제목과 같은 이름으로 자동으록 앵커 링크가 생깁니다. (제목에 공백 부분이 있다면 -로 변환되어 걸립니다.)"
        },
        { type: "img",
            content: "/img/i02.png"
        },
        { type: "text",
            content: "다음과 같은 예제를 작성해 봅시다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section03/exam02.md",
            content:
`# 앵커 링크 예제

- [첫번째 제목](#첫번째-제목)

- [두번째 제목](#두번째-제목)

- [세번째 제목](#세번째-제목)

.

.

.

.

.

## 첫번째 제목

.

.

.

.

.

## 두번째 제목

.

.

.

.

.

## 세번째 제목

.

.

.

.

.

- [처음으로](#앵커-링크-예제)`
        },
        { type: "text",
            content: "문서가 잘 작성되었다면 각 링크를 클릭 했을때 페이지의 스크롤이 잘 이동이 되는지 확인해 봅시다."
        },



        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 이미지 넣기`
        },
        { type: "text",
            content: "이미지를 넣는 방법은 링크를 거는 방법과 매우 유사합니다. 링크 문법 앞에 !(느낌표) 기호만 추가를 하면 됩니다."
        },
        { type: "code2", code: "md", drag: true,
            content: `![설명](이미지주소)`
        },
        { type: "text",
            content: "이미지 주소는 url을 입력할 수 있으며, 내부 파일이면 상대 경로를 사용할 수 있습니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section03/exam03.md",
            content:
`![외부url 이미지](http://devs.co.kr/icon.png)

![내부 이미지 파일](./img/logo.png)`
        },
        


        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 이미지의 크기 조절`
        },
        { type: "text",
            content: "Github의 마크다운 문서에서는 이미지의 크기를 조절하려면 마크다운 문법만으로는 조절할 수 없고 html 태그를 사용해야 합니다."
        },
        { type: "code2", code: "md", drag: true,
            content: `<img src="이미지경로" width="가로크기" height="세로크기">`
        },
        { type: "text",
            content: "가로/세로 크기에는 기본적으로 px(pixel)단위로 입력되며, %(퍼센트)를 사용하면 비율로 잡을 수 있습니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section03/exam04.md",
            content:
`<img src="http://devs.co.kr/icon.png" width="128" height="128">

<img src="./img/logo.png" width="20%">`
        },



        { type: "subtitle",
            content: `<i class="fa fa-check-square"></i> Check it!`
        },
        { type: "oxquiz",
            content: "Github에서 마크다운 문법으로 작성한 링크는 기본적으로 새탭이나 새창으로 이동된다.",
            ans: false,
        },
        { type: "oxquiz",
            content: "Github 마크다운 문서에서는 다른 문서(다른 md파일)의 제목까지 이동하는 링크를 사용할 수 있다.",
            ans: true,
        },
        { type: "oxquiz",
            content: "마크다운 문법으로 첨부한 이미지는 좌측 또는 우측 정렬을 사용할 수 있다",
            ans: false,
        },


        { type: "next",
            content: "다음",
            url: "/sections/04"
        },
    ]
}